/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { ImageListItem } from "@mui/material";
import { GalleryContext } from "cms/documents/document-selector/gallery/gallery-context";
import { DocumentSelectedBadge } from "cms/documents/document-selector/gallery/buttons/document-selected-badge";
import { DocumentSelectCard } from "cms/documents/document-selector/dialog/document-select-card";

const SelectGalleryItem = (props) => {
    
    const {
        isSelected,
        document
    } = props;
    const { guid } = document || {};
    const { setSelectedDocument } = useContext(GalleryContext);
    
    const selectDocument = (event, document) => {
        event.stopPropagation();
        setSelectedDocument(document);
    };
    
    return (
        <>
            <ImageListItem
                className='document-gallery-list-item-card'
                cols={8}
            >
                <div className='document-gallery-list-item'>
                    <DocumentSelectCard
                        document={guid}
                        onClick={(event) => selectDocument(event,document)}
                    >
                        <div className='document-gallery-list-inner-overlay'>
                            {isSelected &&
                                <DocumentSelectedBadge />
                            }
                        </div>
                    </DocumentSelectCard>
                </div>
            </ImageListItem>
        </>
    );
};
export { SelectGalleryItem };
